import { useParams } from "react-router-dom";
import { ContactContentDe } from "./locales/de";

export function ContactContent() {
  const { languageCode } = useParams();

  return languageCode == "de" ? <ContactContentDe /> : <ContactContentDe />;
}
